export default {
  ERROR: 'searchNavigationError',
  CLOSE_SEARCH_NAV_BAR: 'closeSearchNavBar',
  TEXT_CHANGED: 'textChanged',
  BACK_TO_SEARCH: 'backToSearch',
  NAVIGATE_NEXT_SEARCH_SENT: 'navigateNextSearchSent',
  NAVIGATE_PREV_SEARCH_SENT: 'navigatePrevSearchSent',
  NO_RESULTS_INSIDE_BOOK: 'noResultsInsideBook'
};
